<template>
  <tbody data-el="data-table-no-results">
    <tr>
      <td class="border-0">
        <div
          class="data-table-no-results flex flex-col p-3 text-left text-gray-700"
        >
          <CreateNewResourceIcon
            :title="'Create'"
            data-id="data-table-no-results-create-button"
            :no-button="!!(disableNew || searchFilter || page > 0)"
            @click="onNew"
          >
            <span v-if="searchFilter">{{
              'Search did not find any results.'
            }}</span>
            <span v-else>{{ message || 'No results.' }}</span>
          </CreateNewResourceIcon>
        </div>
      </td>
    </tr>
  </tbody>
</template>
<script setup lang="ts">
import CreateNewResourceIcon from '~/components/charts/CreateNewResourceIcon.vue';

const props = withDefaults(
  defineProps<{
    page?: number;
    searchFilter?: string;
    disableNew?: boolean;
    message?: string;
  }>(),
  { page: 0, icon: '', message: '', searchFilter: '' },
);

const emit = defineEmits<{ (e: 'new'): void }>();
const onNew = () => {
  emit('new');
};
</script>
